'use client';

import { cn } from '@/_helpers/cn';

interface ICollapse {
  open: boolean;
  className: string;
  children: React.ReactNode;
}

const openClass = 'h-auto overflow-visible max-h-[100vh]';
const closeClass = 'h-0 overflow-hidden max-h-0';

export const Collapse = ({ className, open, children, ...props }: ICollapse) => (
  <div className={cn(open ? openClass + className : closeClass)} {...props}>
    {children}
  </div>
);

Collapse.displayName = 'Collapse';
